import { Columns } from "react-bulma-components";
import { useSelector } from "react-redux";
import { profileSlice } from "redux/features/profile";
import { useSetTitle } from "util/title";
import { Navigate } from "react-router-dom";

import BasicSummary from "components/basic/summary";
import AffiliationSummary from "components/affiliation/summary";
import { ParticipationList } from "components/participation/summary";
import { ResearchSummary } from "components/research/summary";
import { DemographicsSummary } from "components/demographics";
import { ResponsesRequested } from "components/participation/rsvp";
import RegistrationProgress from "components/participation/registrationProgress";

function Dashboard() {
  const profile = useSelector(profileSlice.selector);
  useSetTitle(null);
  if (
    profile.registrationPending?.require_demographics &&
    profile.itemStatus.affiliation.incomplete
  )
    return <Navigate to="affiliation/current" />;

  if (
    profile.registrationPending?.require_demographics &&
    profile.itemStatus.affiliation.incomplete === false &&
    profile.itemStatus.affiliation.reviewed &&
    profile.itemStatus.demographics.incomplete &&
    Array.from(
      Object.values(profile.itemStatus.demographics.incomplete)
    ).includes(true)
  ) {
    return <Navigate to="demographics" />;
  }

  if (
    profile.registrationPending &&
    profile.itemStatus.affiliation.reviewed &&
    profile.itemStatus.demographics.reviewed
  )
    return <Navigate to={"participation/" + profile.registrationPending.id} />;
  return (
    <div className="wide-container">
      {profile.registrationPending ? (
        <RegistrationProgress forDashboard />
      ) : (
        <ResponsesRequested />
      )}
      <Columns>
        <Columns.Column size="one-third">
          <BasicSummary />
          <DemographicsSummary />
        </Columns.Column>
        <Columns.Column size="one-third">
          <AffiliationSummary />
          <ResearchSummary />
        </Columns.Column>
        <Columns.Column size="one-third">
          <ParticipationList forPast={false} />
          <ParticipationList forPast={true} />
        </Columns.Column>
      </Columns>
    </div>
  );
}

export default Dashboard;
